import React, { useContext, useState } from 'react'
import { BlueConicConfigurationContext } from '../configuration/context'
import { BlueConicMetaFiltersEditor } from './meta-filters/blueconic-meta-filters-editor'
import { BlueConicProductFiltersBuilder } from './blueconic-product-filters'
import { Tabs } from 'antd'
import { MAX_META_FILTERS_VALUE, MAX_PRODUCT_FILTERS_VALUE } from '../constants'

export const BlueConicFiltersEditor = () => {
    const context = useContext(BlueConicConfigurationContext)
    const [activeTab, setActiveTab] = useState('included-filters')

    const includedFiltersLength = context.filters.included.size
    const excludedFiltersLength = context.filters.excluded.size

    const items = [
        {
            key: 'included-filters',
            label: (
                <>
                    Included Filters{' '}
                    <span className="size-label">
                        ({includedFiltersLength}/{MAX_META_FILTERS_VALUE})
                    </span>
                </>
            ),
            className: `included-filters-tab-pane`,
            children: (
                <div className="configuration-included-filters-section">
                    <BlueConicMetaFiltersEditor
                        configId={context.id}
                        filters={context.filters.included}
                        filterType="included"
                    />
                </div>
            ),
        },
        {
            key: 'excluded-filters',
            label: (
                <>
                    Excluded Filters{' '}
                    <span className="size-label">
                        ({excludedFiltersLength}/{MAX_META_FILTERS_VALUE})
                    </span>
                </>
            ),
            className: `excluded-filters-tab-pane`,
            children: (
                <div className="configuration-excluded-filters-section">
                    <BlueConicMetaFiltersEditor
                        configId={context.id}
                        filters={context.filters.excluded}
                        filterType="excluded"
                    />
                </div>
            ),
        },
        {
            key: 'products-filters',
            label: (
                <>
                    Product Filters{' '}
                    <span className="size-label">
                        ({context.filters.products.length}/{MAX_PRODUCT_FILTERS_VALUE})
                    </span>
                </>
            ),
            className: `products-filters-tab-pane`,
            children: (
                <div className="configuration-product-filters-section">
                    <BlueConicProductFiltersBuilder filters={context.filters.products} />
                </div>
            ),
        },
    ]

    return (
        <div className="card-container">
            <Tabs
                className="filters-tabbed-card"
                tabBarGutter={0}
                type="card"
                size="small"
                defaultActiveKey="included-filters"
                activeKey={activeTab}
                onChange={setActiveTab}
                items={items}
            />
        </div>
    )
}
